/* eslint-disable indent */

import {
  Flex,
  Heading,
  // Image
} from '@chakra-ui/react'
// import LOGO_IMPACTO from 'assets/images/brands/impacto/variant_1.svg'
import {
  ActivitiesModuleBrand,
  AppCitizenModuleBrand,
  AttendanceModuleBrand,
  CitizenPortalModuleBrand,
  CitizenProfileModuleBrand,
  DataIntegratorModuleBrand,
  DigitalArchiveModuleBrand,
  GeoModuleBrand,
  InstitutionalManagementModuleBrand,
  InventoryModuleBrand,
  MessengerModuleBrand,
  ProcessesAndDocumentsModuleBrand,
  RegulationModuleBrand,
  SchedulesModuleBrand,
  ServicesLetterModuleBrand,
  UnifiedLoginModuleBrand,
  VulnerabilityAlertsModuleBrand,
  ObservatoryModuleBrand,
  AssessmentsAndResearchModuleBrand,
} from 'components/media'

import { ACTIVITIES_MODULE } from 'Activities/constants/variables/module'
import { APP_CITIZEN_MODULE } from 'AppCitizen/constants/variables/module'
import { ASSESSMENTS_AND_RESEARCH_MODULE } from 'AssessmentsAndResearch/constants/variables/module'
import { ATTENDANCES_MODULE } from 'Attendances/constants/variables/module'
import { CITIZEN_PORTAL_MODULE } from 'CitizenPortal/constants/variables/module'
import { CITIZEN_PROFILE_MODULE } from 'CitizenProfile/constants/variables/module'
import { DATA_INTEGRATOR_MODULE } from 'DataIntegrator/constants/variables/module'
import { DIGITAL_ARCHIVE_MODULE } from 'DigitalArchive/constants/variables/module'
import { GEO_MODULE } from 'Geo/constants/variables/module'
import { INSTITUTIONAL_MANAGEMENT_MODULE } from 'InstitutionalManagement/constants/variables/module'
import { INVENTORY_MODULE } from 'Inventory/constants/variables/module'
import { MESSENGER_MODULE } from 'Messenger/constants/variables/module'
import { REGULATION_MODULE } from 'Regulation/constants/variables/module'
import { SCHEDULES_MODULE } from 'Schedules/constants/variables/module'
import { SERVICES_LETTER_MODULE } from 'ServicesLetter/constants/variables/module'
import { UNIFIED_LOGIN_MODULE } from 'UnifiedLogin/constants/variables/module'
import { ALERTS_OF_VULNERABILITY_MODULE } from 'AlertsOfVulnerability/constants/variables/module'
import { OBSERVATORY_MODULE } from 'Observatory/constants/variables/module'
import { PROCESSES_AND_DOCUMENTS_MODULE } from 'modules/ProcessesAndDocuments/constants/variables'

export default function ModuleBrand({ module }: { module: string }) {
  switch (module.toUpperCase()) {
    case 'ACTIVITIES':
      return (
        <Flex alignItems="center" gap={2}>
          <ActivitiesModuleBrand />
          <Heading fontSize="lg">{ACTIVITIES_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )
    case 'APP_CITIZEN':
      return (
        <Flex alignItems="center" gap={2}>
          <AppCitizenModuleBrand />
          <Heading fontSize="lg">{APP_CITIZEN_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'ASSESSMENTS_AND_RESEARCH':
      return (
        <Flex alignItems="center" gap={2}>
          <AssessmentsAndResearchModuleBrand />
          <Heading fontSize="lg">{ASSESSMENTS_AND_RESEARCH_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'ATTENDANCES':
      return (
        <Flex alignItems="center" gap={2}>
          <AttendanceModuleBrand />
          <Heading fontSize="lg">{ATTENDANCES_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'CITIZEN_PORTAL':
      return (
        <Flex alignItems="center" gap={2}>
          <CitizenPortalModuleBrand />
          <Heading fontSize="lg">{CITIZEN_PORTAL_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'CITIZEN_PROFILE':
      return (
        <Flex alignItems="center" gap={2}>
          <CitizenProfileModuleBrand />
          <Heading fontSize="lg">{CITIZEN_PROFILE_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'DATA_INTEGRATOR':
      return (
        <Flex alignItems="center" gap={2}>
          <DataIntegratorModuleBrand />
          <Heading fontSize="lg">{DATA_INTEGRATOR_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'DIGITAL_ARCHIVE':
      return (
        <Flex alignItems="center" gap={2}>
          <DigitalArchiveModuleBrand />
          <Heading fontSize="lg">{DIGITAL_ARCHIVE_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'GEO':
      return (
        <Flex alignItems="center" gap={2}>
          <GeoModuleBrand />
          <Heading fontSize="lg">{GEO_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'INSTITUTIONAL_MANAGEMENT':
      return (
        <Flex alignItems="center" gap={2}>
          <InstitutionalManagementModuleBrand />
          <Heading fontSize="lg">{INSTITUTIONAL_MANAGEMENT_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'INVENTORY':
      return (
        <Flex alignItems="center" gap={2}>
          <InventoryModuleBrand />
          <Heading fontSize="lg">{INVENTORY_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'MESSENGER':
      return (
        <Flex alignItems="center" gap={2}>
          <MessengerModuleBrand />
          <Heading fontSize="lg">{MESSENGER_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'OBSERVATORY':
      return (
        <Flex alignItems="center" gap={2}>
          <ObservatoryModuleBrand />
          <Heading fontSize="lg">{OBSERVATORY_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'PROCESSES_AND_DOCUMENTS':
      return (
        <Flex alignItems="center" gap={2}>
          <ProcessesAndDocumentsModuleBrand />
          <Heading fontSize="lg">{PROCESSES_AND_DOCUMENTS_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'REGULATION':
      return (
        <Flex alignItems="center" gap={2}>
          <RegulationModuleBrand />
          <Heading fontSize="lg">{REGULATION_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'SCHEDULES':
      return (
        <Flex alignItems="center" gap={2}>
          <SchedulesModuleBrand />
          <Heading fontSize="lg">{SCHEDULES_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'SERVICES_LETTER':
      return (
        <Flex alignItems="center" gap={2}>
          <ServicesLetterModuleBrand />
          <Heading fontSize="lg">{SERVICES_LETTER_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'UNIFIED_LOGIN':
      return (
        <Flex alignItems="center" gap={2}>
          <UnifiedLoginModuleBrand />
          <Heading fontSize="lg">{UNIFIED_LOGIN_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'VULNERABILITY_ALERTS':
      return (
        <Flex alignItems="center" gap={2}>
          <VulnerabilityAlertsModuleBrand />
          <Heading fontSize="lg">{ALERTS_OF_VULNERABILITY_MODULE.NAME_PTBR}</Heading>
        </Flex>
      )

    case 'GENERAL':
      return (
        <Flex alignItems="center" gap={2}>
          {/* <Image src={LOGO_IMPACTO.src} w="auto" h="30px" alt="Logo da Impacto" /> */}
          <Heading fontSize="lg">Geral</Heading>
        </Flex>
      )

    default:
      return <></>
  }
}
